const themeType = {
  TOURNAMENT: 'tournament',
  FACILITY: 'facility',
};

export default themeType;
